<template>
  <div class="cplan-period">
    <div class="cplan-period__head">
      {{ teachingPeriodLabel }}
    </div>
    <div class="cplan-period__body">
      <template v-for="unit in teachingPeriod.units">
        <SavedPlanUnitCard :key="unit.code" :unit="unit" :year="year" :teachingPeriod="teachingPeriod.teachingScheduled" />
      </template>
      <template v-for="emptyUnit in placeholderCards">
        <div class="cplan-unit-card-outer empty print-hide" :key="emptyUnit">
          <div class="cplan-unit-card-empty"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import SavedPlanUnitCard from './SavedPlanUnitCard.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {
    teachingPeriod: { type: Object, required: true },
    teachingPeriodTitle: { type: String, required: true },
    year: { type: Number, required: true },
    teachingPeriodLabel: { type: String, required: true }
  },
  data() {
    return {
      showMaxCreditControl: false
    }
  },
  methods: {
    ...mapActions({
      generateCoursePlan: 'plans/generateCoursePlan'
    })
  },
  computed: {
    placeholderCards() {
      var periodCredits = 0
      this.teachingPeriod.units.forEach((unit) => (periodCredits = periodCredits + unit.creditPoints))
      var emptySlots = Math.floor((this.teachingPeriod.workload - periodCredits) / 3)
      return emptySlots > 0 ? emptySlots : null
    },
    teachingPeriodFormatted() {
      return this.teachingPeriodTitle + '-' + this.teachingPeriod.teachingScheduled
    }
  },
  mounted() {
    // Prevent click outside event with popupItem
    this.popupItem = this.$refs.maxUnitToggle
  },
  directives: {
    ClickOutside
  },
  components: { SavedPlanUnitCard }
}
</script>

